import { render, staticRenderFns } from "./ImageSizeSelector.vue?vue&type=template&id=441e37a5&"
import script from "./ImageSizeSelector.vue?vue&type=script&lang=js&"
export * from "./ImageSizeSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports